import { useRef, useState, useEffect } from 'react';

import { useInView } from 'react-intersection-observer';

import { calculateElementHeight } from './utils';

export function useShowMore(
  initialHeight: number,
  initialIsCollapsbible?: boolean
) {
  const [isOpen, setIsOpen] = useState(false);
  const [isCollapsible, setIsCollapsible] = useState(
    initialIsCollapsbible ?? true
  );

  const baseRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const disabledRef = useRef(true);

  const { ref: markerRef, inView: isMarkerInView } = useInView();

  const handleOpenChange = (open: boolean) => {
    if (!open && baseRef.current) {
      baseRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleShowMoreClick = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      const shouldCollapse = entry.contentBoxSize[0].blockSize > initialHeight;
      setIsCollapsible(shouldCollapse);
    });

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => observer.disconnect();
  }, [initialHeight]);

  useEffect(() => {
    if (contentRef.current) {
      const shouldCollapse =
        calculateElementHeight(contentRef.current) > initialHeight;
      setIsCollapsible(shouldCollapse);
    }

    disabledRef.current = false;
  }, [initialHeight]);

  return {
    isOpen,
    isCollapsible,
    isButtonDisabled: disabledRef.current,
    isMarkerInView,
    handleOpenChange,
    handleShowMoreClick,
    baseRef,
    contentRef,
    markerRef,
  };
}
